import { Autocomplete, FormControl, TextField } from "@mui/material";
import { SyntheticEvent, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchNearbyPharmaciesQuery } from "src/api/services/e-prescribeApi";
import { EPrescribePharmacy, PatientPreferredPharmacy } from "src/api/types";

interface Props {
  patientPharmacy: PatientPreferredPharmacy | undefined;
  selectedPharmacy: EPrescribePharmacy | null;
  setSelectedPharmacy: (v: EPrescribePharmacy | null) => void;
}

const PharmacyAutocomplete = ({
  patientPharmacy,
  setSelectedPharmacy,
  selectedPharmacy,
}: Props) => {
  const { data = [] } = useSearchNearbyPharmaciesQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const { t } = useTranslation();
  const page = "pharmacy-search";

  const handleOnChange = useCallback(
    (_: SyntheticEvent, newValue: EPrescribePharmacy | null) => {
      setSelectedPharmacy(newValue);
    },
    [setSelectedPharmacy],
  );
  useEffect(() => {
    if (patientPharmacy == null) return;

    const matchedPharmacy =
      data.find(
        (pharmacy) =>
          pharmacy.PharmacyId === Number(patientPharmacy.external_pharmacy_id),
      ) ?? null;
    setSelectedPharmacy(matchedPharmacy);
  }, [data, patientPharmacy, setSelectedPharmacy]);

  return (
    <FormControl fullWidth required sx={{ gap: 1 }}>
      <Autocomplete
        options={data}
        getOptionLabel={(option) =>
          `${option.StoreName} - ${option.Address1}, ${option.City}, ${option.State} `
        }
        renderInput={(params) => (
          <TextField
            {...params}
            required
            name="pharmacy"
            id="pharmacy"
            label={`${t(`${page}.pharmacy.label`)}...`}
          />
        )}
        value={selectedPharmacy}
        onChange={handleOnChange}
      />
    </FormControl>
  );
};

export default PharmacyAutocomplete;
